import React from 'react';
import { Player, TeamInLeague, TrainingFocus } from '../../../domain/entities';
import { INDIVIDUAL_PLAYER_ATTRIBUTES } from '../../../domain/constants';

interface PlayerTrainingPanelProps {
    player: Player;
    team: TeamInLeague;
    onUpdatePlayerTrainingFocus: (playerId: number, focus: TrainingFocus | null) => void;
    facilitiesLevel: number;
}

const trainingFocusOptions: TrainingFocus[] = ['General', 'Fitness', 'Rest', 'Goalkeeping', 'Defending', 'Midfield', 'Attacking'];

export const PlayerTrainingPanel: React.FC<PlayerTrainingPanelProps> = ({ player, team, onUpdatePlayerTrainingFocus, facilitiesLevel }) => {
    // Determine what the team default training is for this player
    const teamDefaultTraining = team.positionalTrainingFocus[player.position] || team.trainingFocus;

    return (
        <div className="panel">
            <div className="panel-header">Individual Training</div>
            <div className="panel-content">
                {facilitiesLevel < 3 ? (
                    <>
                        <select
                            value={player.trainingFocus || 'team'}
                            onChange={(e) => onUpdatePlayerTrainingFocus(player.id, e.target.value === 'team' ? null : e.target.value as TrainingFocus)}
                            style={{width: '100%'}}
                        >
                            <option value="team">Follow Team Focus ({teamDefaultTraining})</option>
                            {trainingFocusOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                        </select>
                        <p style={{ marginTop: '12px', fontSize: '0.85em', opacity: 0.7 }}>
                            <strong>Tip:</strong> Upgrade training facilities to Level 3 to unlock individual attribute targeting for more precise player development.
                        </p>
                    </>
                ) : (
                    <>
                        <p style={{ fontSize: '0.9em', marginBottom: '12px' }}><strong>Choose training focus (positional or specific attribute):</strong></p>
                        <select
                            value={player.trainingFocus || 'team'}
                            onChange={(e) => onUpdatePlayerTrainingFocus(player.id, e.target.value === 'team' ? null : e.target.value as TrainingFocus)}
                            style={{width: '100%'}}
                        >
                            <option value="team">Follow Team Focus ({teamDefaultTraining})</option>
                            <optgroup label="Position-Based Training">
                                {trainingFocusOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                            </optgroup>
                            <optgroup label="Attribute-Specific Training">
                                {INDIVIDUAL_PLAYER_ATTRIBUTES.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                            </optgroup>
                        </select>
                    </>
                )}
            </div>
        </div>
    );
};
